<div class="aero-textarea">

  <label *ngIf="label"
       [for]="id"
       [ngClass]="{'bulb-required': required}">
    {{label}}
  </label>
  <div class="bulb-textarea-label-wrapper">
    <textarea pTextarea
          #textarea="ngModel"
          [id]="id"
          [attr.aria-label]="ariaLabel"
          [ngClass]="{'bulb-auto-resize': autoResize}"
          [rows]="rows"
          [cols]="columns"
          [required]="required"
          [placeholder]="placeholder"
          [maxLength]="maxlength"
          [disabled]="disabled"
          [autoResize]="autoResize"
          [name]="name"
          [(ngModel)]="textareaValue"
          [bulbAutofocus]="autofocus"
          (blur)="onBlur()"
          (input)="onContentChange($event)"
          (ngModelChange)="updateChanges()">
    </textarea>
    <div class="right"
       *ngIf="textarea.invalid && (textarea.dirty || textarea.touched)">
      <span class="error-icon-tooltip right">
        <i class="fa fa-exclamation-circle error-icon"
           aria-hidden="true">
        </i>
      </span>
    </div>
    <span class="bulb-hint-message"
        [ngClass]="{'bulb-hint-error-message': textarea.invalid && (textarea.dirty || textarea.touched)}">
      {{textareaValue ? textareaValue?.length : 0}}/{{maxlength}}
    </span>
  </div>
  <div class="bulb-error-wrapper">
    <span class="bulb-bottom-error-msg"
        *ngIf="textarea.invalid && (textarea.dirty || textarea.touched)">
      {{errorMessage}}
    </span>
  </div>

</div>
